export default __webpack_public_path__ + "media/images/svg/ico-telephone-9b0571ed334d2f441b02ed259126e944.svg";